<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>当前积分：{{point}}</span>
<!--            <a-button type="primary" style="margin-left: 15px" @click="$refs.useModal.showForm('用户使用消费券', {point})">消费使用</a-button>-->
        </div>
        <a-divider>使用记录</a-divider>
        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                style="width: 70%; margin-left: 15%"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

        </a-table>
        <use-modal ref="useModal" @use="handleUse"></use-modal>
    </div>
</template>

<script>

    import vendorAdminService from "@/service/vendorAdmin";
    import moment from "moment"
    import UseModal from "./UseModal";

    export default {
        components: {UseModal},
        data() {
            return {
                columns: [
                    {title: '#', width: "10%", scopedSlots: { customRender: 'serial' }},
                    {title: '顾客昵称',width: "18%", dataIndex: 'userNickname',},
                    {title: '消费金额',width: "12%", dataIndex: 'amount', customRender: (text) => text + "元"},
                    {title: '消费券面额',width: "12%", dataIndex: 'couponValue', customRender: (text) => text + "元"},
                    {title: '使用时间',width: "20%", dataIndex: 'updateTime', customRender: (text) => moment(new Date(text)).format("YYYY-MM-DD HH:mm:ss")},
                ],
                rows: [],
                pagination: {},

                point: 0
            }
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                this.fetch({
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                })
            },
            fetch(params) {
                vendorAdminService.couponUsedList(params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.record.records

                    pagination.current = res.data.record.current
                    pagination.total = res.data.record.total
                    pagination.pageSize = res.data.record.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }

                    this.point = res.data.point
                    this.pagination = pagination
                });
            },
            handleUse(useInfo) {
                vendorAdminService.doCouponUse(
                    useInfo
                ).then((res)=>{
                    this.$success({
                        title: "消费成功！"
                    })
                    this.$refs.useModal.confirmLoading = false
                    this.$refs.useModal.visible = false

                    this.fetch({
                        pageNo: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        keyword: this.keyword
                    })
                }).catch((res)=>{
                    this.$refs.useModal.confirmLoading = false
                })

            }
        }
    }
</script>

<style scoped>

</style>
